import 'promise-polyfill/src/polyfill';
import '../scss/help.scss';
// import { Slider } from 'efile-ui';

import './modules/video';

if(window.location.hash) {
    var anchor = $(window.location.hash);
    if(anchor.length) {
        console.log('Anchor: '+anchor.length);
        $(anchor).parent().children('.help__header').removeClass('collapsed');
        $(anchor).parent().children('.collapse').addClass('show');
    }
}

$('.help__header').on('click', function() {
    $(this).toggleClass('collapsed');
    $(this).siblings('.collapse').slideToggle();
});


if ($('[rel*="lightbox"]').length) {
  import('./modules/lightbox').then(() => {}).catch((error) => {
    console.error(error);
  });;
}




$('.tags-menu a').on('click', function() {
    $('#player').attr('data-yt-id','uCZAJLL7PZo');

    $(this).toggleClass('active');
    $('.help__video__items').toggleClass('show-tag-'+$(this).attr('data-tag'));

    $('.help__video__items__link').each(function() {
        let itemShow= false;

        let tagClass = Array();
        $('.tags-menu-item .but.active').each(function() {
            tagClass.push('tag'+$(this).attr('data-tag'));
        });

        if (tagClass.length>0) {
            tagClass.forEach((item)=>{
                if ($(this).hasClass(item)) {
                    itemShow = true;
                }
            });

            if (itemShow) {
                $(this).show();
            } else {
                $(this).hide();
            }
        } else {
            $(this).show();
        }
    });
});

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('hv_tag')) {
    let hv_tag_set= '.hv_tag_'+urlParams.get('hv_tag');
    // console.log('hv_tag_set: '+$(hv_tag_set).length);

    if ($(hv_tag_set).length) {
        $(hv_tag_set).click();
        $('.help__video__main').hide();
        $('.help__video__menu h2').text('Wybrane filmy');
    }
}